import React from "react"
import { useNavigate, useLocation } from "react-router-dom"
import emotions from "../data/emotions.json"
import { useEmotionFilter } from "../context/EmotionFilterContext"
import "./EmotionsFooter.css"

const EmotionsFooter = () => {
  const { emotion: active, setEmotion } = useEmotionFilter()
  const navigate = useNavigate()
  const location = useLocation()

  const handleEmotionClick = (emotion) => {
    setEmotion(emotion)
    // the wheel lives on the home page — make sure we're there to see the filter
    if (location.pathname !== "/" && location.pathname !== "/home") {
      navigate("/")
    }
  }

  return (
    <div className="circlesFooter">
      {emotions.colors.map((colorObj, index) => {
        const isActive = active === colorObj.emotion
        const dimmed = active && !isActive
        return (
          <div key={index} className={`colored-circle ${isActive ? "is-active" : ""} ${dimmed ? "is-dimmed" : ""}`}>
            <div
              className="emotion-dot"
              onClick={() => handleEmotionClick(colorObj.emotion)}
              style={{ backgroundColor: colorObj.color }}
            />
            <p>{colorObj.emotion}</p>
          </div>
        )
      })}
    </div>
  )
}

export default EmotionsFooter
